module.exports = __webpack_public_path__ + "static/media/n3.a785e2a0.jpg";